module.exports = __webpack_public_path__ + "img/unknown-2.68cae089.webp";